import { regexForm } from 'components/utils/regexForm'
import { validationCNPJ } from 'components/utils/validationsFN'
import formatter from 'utils/formatter'
import * as yup from 'yup'

export const Schema = yup
    .object({
        cnpj: yup
            .string()
            .required()
            .matches(regexForm.cnpj)
            .transform(value => formatter.cnpj(value))
            .test({
                name: 'invalid',
                test: value => !!value && validationCNPJ(value as string)
            }),
        razaoSocial: yup.string().required().min(3),
        IE: yup.string(),
        IM: yup.string(),
        email: yup.string().required().email(),
        contato: yup
            .string()
            .required()
            .transform(value => formatter.contato(value))
            .matches(regexForm.contato)
    })
    .required()
